import React, { useState } from "react";
import { toast } from "react-toastify";
import { bulkSendOrdersToPrintlet, previewPrintletSend, sendOrderToPrintlet } from "../api/PrintletAPIs";
import { canMutateOrders } from "../utils/roles";

export default function SendToPrintletButton({ orderId, orderIds, disabled, className = "", onSuccess }) {
  const [busy, setBusy] = useState(false);
  const ids = orderIds?.length ? orderIds : orderId ? [orderId] : [];
  if (!ids.length) return null;

  const send = async () => {
    if (busy || disabled) return;
    try {
      setBusy(true);
      if (ids.length === 1) {
        const preview = await previewPrintletSend(ids[0]);
        const extra = [
          ...(preview.errors || []),
          ...(preview.warnings || []),
        ].join("\n");
        const ok = window.confirm(
          `إرسال الطلب #${ids[0]} إلى Printlet؟\nحالة جراباتكم لن تتغير.\n\n` +
            (preview.mixedFulfillment ? "تحذير: الطلب مختلط — البنود الجاهزة لن تُرسل.\n" : "") +
            (extra ? extra + "\n\n" : "") +
            (preview.eligible ? "متابعة؟" : "الطلب غير صالح حالياً. عرض التفاصيل فقط؟")
        );
        if (!ok) return;
        if (!preview.eligible && (preview.errors || []).length) {
          toast.error(preview.errors[0]);
          return;
        }
        const result = await sendOrderToPrintlet(ids[0]);
        if (result.outcome === "already_sent") {
          toast.info(`الطلب #${ids[0]} مُرسل بالفعل`);
          onSuccess?.(ids[0], "Printlet");
        } else if (result.outcome === "success") {
          toast.success(`تم إرسال #${ids[0]} إلى Printlet`);
          onSuccess?.(ids[0], "Printlet");
        } else toast.error(result.error || "فشل الإرسال إلى Printlet");
      } else {
        const ok = window.confirm(`أنت على وشك إرسال ${ids.length} طلب(ات) إلى Printlet.\nلن يتم التراجع عن الطلبات الناجحة إذا فشل غيرها.`);
        if (!ok) return;
        const result = await bulkSendOrdersToPrintlet(ids);
        toast.info(`نجاح ${result.success} · فشل ${result.failed} · مُرسل مسبقاً ${result.alreadySent} · متخطى ${result.skipped}`);
        (result.results || [])
          .filter((r) => r.outcome === "failed")
          .slice(0, 5)
          .forEach((r) => toast.error(`#${r.orderId}: ${r.error}`));
        const routed = (result.results || []).filter((r) => r.outcome === "success" || r.outcome === "already_sent");
        if (routed.length) onSuccess?.(routed.map((r) => r.orderId), "Printlet");
      }
    } catch (err) {
      toast.error(err.message || "فشل الإرسال إلى Printlet");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      disabled={busy || disabled}
      onClick={send}
      className={className || "px-3 py-2 rounded-xl bg-fuchsia-600 text-white disabled:opacity-50"}
    >
      {busy ? "جاري الإرسال..." : ids.length > 1 ? `إرسال لـ Printlet (${ids.length})` : "إرسال لـ Printlet"}
    </button>
  );
}

export function canShowPrintletSend(role) {
  return canMutateOrders(role);
}
